import {ParamsModel} from 'src/app/modules/common/Model'
import {NabilAuctionSubscriberModel} from '../Model/Model'
import {actionTypes} from './constants'

export const actions = {
  // get NabilAuctionSubscriber
  getNabilAuctionSubscriber: (params: ParamsModel = {page: 1, limit: 10}) => ({
    type: actionTypes.GET_NABIL_AUCTION_SUBSCRIBER_START,
    payload: params,
  }),
  getNabilAuctionSubscriberSuccess: (data: NabilAuctionSubscriberModel | any) => ({
    type: actionTypes.GET_NABIL_AUCTION_SUBSCRIBER_SUCCESS,
    payload: data,
  }),
  getNabilAuctionSubscriberFinish: () => ({
    type: actionTypes.GET_NABIL_AUCTION_SUBSCRIBER_FINISH,
  }),

  // delete
  deleteNabilAuctionSubscriber: (data: string[]) => ({
    type: actionTypes.DELETE_NABIL_AUCTION_SUBSCRIBER_START,
    payload: {ids: data},
  }),
  deleteNabilAuctionSubscriberSuccess: (data: any) => ({
    type: actionTypes.DELETE_NABIL_AUCTION_SUBSCRIBER_SUCCESS,
    payload: data,
  }),
  deleteNabilAuctionSubscriberFinish: () => ({
    type: actionTypes.DELETE_NABIL_AUCTION_SUBSCRIBER_FINISH,
  }),

  // Enable
  enableNabilAuctionSubscriber: (data: any) => ({
    type: actionTypes.ENABLE_NABIL_AUCTION_SUBSCRIBER_REQUEST,
    payload: {data},
  }),

  enableNabilAuctionSubscriberSuccess: (task: any) => ({
    type: actionTypes.ENABLE_NABIL_AUCTION_SUBSCRIBER_SUCCESS,
    payload: task,
  }),
  enableNabilAuctionSubscriberFinish: () => ({
    type: actionTypes.ENABLE_NABIL_AUCTION_SUBSCRIBER_FINISH,
  }),

  // Disable
  disableNabilAuctionSubscriber: (data: any) => ({
    type: actionTypes.DISABLE_NABIL_AUCTION_SUBSCRIBER_REQUEST,
    payload: {data},
  }),

  disableNabilAuctionSubscriberSuccess: (task: any) => ({
    type: actionTypes.DISABLE_NABIL_AUCTION_SUBSCRIBER_SUCCESS,
    payload: task,
  }),
  disableNabilAuctionSubscriberFinish: () => ({
    type: actionTypes.DISABLE_NABIL_AUCTION_SUBSCRIBER_FINISH,
  }),

  // Single Enable
  singleEnableNabilAuctionSubscriber: (data: any) => ({
    type: actionTypes.SINGLE_ENABLE_NABIL_AUCTION_SUBSCRIBER_REQUEST,
    payload: {data},
  }),

  singleEnableNabilAuctionSubscriberSuccess: (task: any) => ({
    type: actionTypes.SINGLE_ENABLE_NABIL_AUCTION_SUBSCRIBER_SUCCESS,
    payload: task,
  }),
  singleEnableNabilAuctionSubscriberFinish: () => ({
    type: actionTypes.SINGLE_ENABLE_NABIL_AUCTION_SUBSCRIBER_FINISH,
  }),

  // Single Disable
  singleDisableNabilAuctionSubscriber: (data: any) => ({
    type: actionTypes.SINGLE_DISABLE_NABIL_AUCTION_SUBSCRIBER_REQUEST,
    payload: {data},
  }),

  singleDisableNabilAuctionSubscriberSuccess: (task: any) => ({
    type: actionTypes.SINGLE_DISABLE_NABIL_AUCTION_SUBSCRIBER_SUCCESS,
    payload: task,
  }),
  singleDisableNabilAuctionSubscriberFinish: () => ({
    type: actionTypes.SINGLE_DISABLE_NABIL_AUCTION_SUBSCRIBER_FINISH,
  }),
}
